/**
 * Sales Pipeline — types and stage constants.
 * Mirrors frontend-bk/erp/src/data/constants.js PIPELINE_STAGES + LEAD_SOURCES.
 * Leads live one row each in `sales_leads` (migration `ban_giao_khach_dang_giu`, G4-3a) behind
 * /sales-leads; the old app_config["sales_leads"] blob is kept read-only.
 */
import type { components } from "@/lib/api/generated/schema";

/** One lead as the server returns it; `ownerStaffId` "" = "Chưa giao". */
export type Lead = components["schemas"]["SalesLead"];
export type LeadInput = components["schemas"]["SalesLeadInput"];

/** Editable fields of a lead, without server-owned ones. */
export function leadInput(l: Lead): LeadInput {
  return {
    customer: l.customer,
    phone: l.phone,
    source: l.source,
    stage: l.stage,
    category: l.category,
    notes: l.notes,
    followUpDate: l.followUpDate,
    lostReason: l.lostReason,
    convertedOrderId: l.convertedOrderId,
  };
}

export interface StageDef {
  value: string;
  label: string;
  color: string;
  bg: string;
}

export const PIPELINE_STAGES: StageDef[] = [
  { value: "new",        label: "Mới nhận",     color: "#1d4ed8", bg: "#dbeafe" },
  { value: "consulting", label: "Đang tư vấn",  color: "#b45309", bg: "#fef3c7" },
  { value: "quoted",     label: "Đã báo giá",   color: "#6d28d9", bg: "#ede9fe" },
  { value: "scheduled",  label: "Đã chốt",      color: "#047857", bg: "#d1fae5" },
  { value: "lost",       label: "Mất",          color: "#374151", bg: "#f3f4f6" },
];

// `value` là mã đã nằm trong lead cũ — giữ nguyên "google" dù nhãn đổi thành
// "Web + Google" (CEO 19/08/2026), nếu đổi mã thì lead cũ mất nhãn.
export const LEAD_SOURCES: Array<{ value: string; label: string }> = [
  { value: "facebook",  label: "Facebook" },
  { value: "instagram", label: "Instagram" },
  { value: "tiktok",    label: "TikTok" },
  { value: "google",    label: "Web + Google" },
  { value: "zalo",      label: "Zalo" },
  { value: "hotline",   label: "Hotline" },
  { value: "referral",  label: "Giới thiệu" },
  { value: "walkin",    label: "Walk-in" },
  { value: "other",     label: "Khác" },
];
